import { Component, Ref, Prop } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class MobilePanelTrigger extends ThemeComponent {
    @Prop() target!: string;
    @Ref() openButton!: HTMLButtonElement;
    init() {
        this.$listen(this.openButton, 'click', () => {
            const targetElement = document.querySelector(`mobile-panel[data-target="${this.target}"`);

            if (targetElement) {
                targetElement.classList.add('mobile-panel--active');
                document.body.classList.add('mobile-panel-open');
            }
        });
    }
}
